import React, { Fragment } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { actions as adheredServicesActions } from "reducers/adheredServices";
import Notification from "pages/_components/Notification";
import I18n from "pages/_components/I18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import GridTable from "pages/_components/GridTable/GridTable";
import DataRemoveService from "./components/DataRemoveService";

const RemoveService = () => {
    const { fetching, adheredServicesData } = useSelector((state) => state.adheredServices);
    const dispatch = useDispatch();
    const handleSubmit = () => {
        gaEventTracker.triggerEvent(events.pagos_desvincular({ empresa: adheredServicesData?.alias }));
        dispatch(adheredServicesActions.adheredServicesRemoveReducer(adheredServicesData?.serviceId));
    };
    return (
        <Fragment>
            <Notification scopeToShow="adheredService.remove" />
            <ResponsiveHeader id="adheredService.unbind.service" />
            <MainContainer showLoader={fetching}>
                <div className="container">
                    <h2 className="text-lead" style={{ fontWeight: 500 }}>
                        <I18n id="adheredService.control.data" />
                    </h2>

                    <DataRemoveService
                        company={adheredServicesData?.companyCode}
                        reference={adheredServicesData?.alias}
                        paymentCode={adheredServicesData?.paymentModeId}
                    />
                    <GridTable className="grid-table-buttons">
                        <GridTable.Container>
                            <GridTable.Data columnStart={5} columnWidth={4}>
                                <div className="form-group">
                                    <div className="form-group">
                                        <span className="data-label">
                                            <span> &nbsp;</span>
                                        </span>
                                        <div className="button-group">
                                            <Button
                                                // className="btn btn-primary"
                                                label="adheredService.unbind.label"
                                                onClick={handleSubmit}
                                                block
                                                bsStyle="primary"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                    {/* <MobileButtons>
                        <Action labelKey="adheredService.unbind.label" handleClick={handleSubmit} />
                    </MobileButtons> */}
                </div>
            </MainContainer>
        </Fragment>
    );
};

export default RemoveService;
